// services/productService.js
import axios from 'axios';

export const productService = {
  async getProducts() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/products`);
      
      // Se a resposta já estiver no formato esperado (com regular e packages)
      if (response.data.data.regular && response.data.data.packages) {
        return response.data.data;
      }
      
      // Caso contrário, assumir que são apenas produtos regulares
      return {
        regular: response.data.data,
        packages: []
      };
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
      throw error;
    }
  }
};